export default __webpack_public_path__ + "static/media/property_1011.287a25fa.png";